<div class="snackbar-content">
  <mat-icon class="snackbar-icon">
    {{ data.icon }}
  </mat-icon>
  <span class="snackbar-message">{{ data.message }}</span>
</div>

